import i18n from '@/utils/i18n'

export default {
  methods: {
    getErrorLabelTranslation (field, isPrelogged) {
      let ret = ''
      let needTranslation = true

      switch (field) {
        case 'destination':
          ret = 'home.form.destination.'
          ret += isPrelogged ? 'preloggedLabel' : 'label'
          break
        case 'favorite':
          ret = 'home.form.favorite.'
          ret += isPrelogged ? 'preloggedLabel' : 'label'
          break
        case 'bedrooms': ret = '_travellers'
          break
        case 'from': ret = '_starting_date'
          break
        case 'to': ret = '_ending_date'
          break
        case 'dates': ret = '_dates'
          break
        case 'extra': ret = 'offline.extra.title'
          break
        case 'researchPriority': ret = 'offline.research_priority.question'
          break
        case 'travellers': ret = 'offline.contact_details.traveller.title'
          break
        case 'emailCC':ret = isPrelogged ? '_email_copies_elior' : '_email_copies'
          break
        case 'bedType': ret = '_bedType'
          break
        case 'managers': ret = 'booking.managersValidation.errorLabel'
          break
        default:
          if (field.match(/custom-field-[1-6]*/)) {
            let arr = field.split('-')
            let id = parseInt(arr[arr.length - 1])

            for (let customField of this.formData.customFields) {
              if (customField.id === id) {
                ret = customField.label
                needTranslation = false
              }
            }
          }
          if (field.match(/traveller-*/)) {
            let arr = field.split('-')
            let id = arr[arr.length - 1]
            ret = i18n.t('traveller.defaults') + ' : ' + i18n.t('traveller.fields.' + id)
            needTranslation = false
          }
      }

      return needTranslation ? i18n.t(ret) : ret
    }
  }
}
